var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingTourDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4749_13187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59191 5.93123C8.87932 4.36683 10.3805 3.33162 11.9449 3.61902L18.4397 4.81222C19.191 4.95024 19.8566 5.38103 20.2903 6.00984L24.2375 11.7337C24.6711 12.3626 24.8371 13.1379 24.6991 13.8891L22.4651 26.0491C22.1777 27.6135 20.6766 28.6487 19.1122 28.3613L7.78178 26.2798C6.21738 25.9924 5.18217 24.4912 5.46958 22.9268L8.59191 5.93123ZM9.86334 14.9494C10.007 14.1672 10.7576 13.6496 11.5398 13.7933L20.0376 15.3545C20.8198 15.4982 21.3374 16.2488 21.1937 17.031C21.05 17.8132 20.2994 18.3308 19.5172 18.1871L11.0194 16.6259C10.2372 16.4822 9.71964 15.7316 9.86334 14.9494ZM10.4991 19.4585C9.71686 19.3148 8.96626 19.8324 8.82256 20.6146C8.67886 21.3968 9.19647 22.1474 9.97867 22.2911L18.4765 23.8523C19.2587 23.996 20.0092 23.4784 20.1529 22.6962C20.2966 21.914 19.779 21.1634 18.9968 21.0197L10.4991 19.4585Z",
    fill: "#823FC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4749_13187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.648,
    height: 27.648,
    fill: "white",
    transform: "translate(4.99609) rotate(10.41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTourDocument);
export default __webpack_public_path__ + "static/media/onboarding-tour-document.4e58f2dbfa893c9b8214c160dfad5f4c.svg";
export { ForwardRef as ReactComponent };